import React,{Component} from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from  '../Vas';
import '../css/SideNavigationCustomerCard.css';
import CustomerData from "../components/vas/CustomerCard/CustomerData";
import CustomerPaymentData from "../components/vas/CustomerCard/CustomerPaymentData";
import CustomerDocumentData from "../components/vas/CustomerCard/CustomerDocumentData";
import CustomerCertificateData from "../components/vas/CustomerCard/CustomerVerificationData";
import CustomerAdditionalAdresses from "../components/vas/CustomerCard/CustomerAddressData";
import CustomerContractData from "../components/vas/CustomerCard/CustomerContractData";

import CustomerRelationDelete from "../components/vas/CustomerCard/CustomerRelationDelete";

class SideNavigationCustomerCard extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.CurrentView = "CustomerData";
        this.CustomerId = this.props.id;     
    }

    CustomerId = "";

    Update()
    {
        this.setState({});
    }
    
    openLoader(){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
    }

    GetCustomerData(){
        this.openLoader();
        return (<CustomerData id={this.CustomerId} />);
    }

    GetCustomerPaymentData(){
        this.openLoader();
        return (<CustomerPaymentData
          id={this.CustomerId}
          me={this} />);
    }

    GetCustomerDocumentData(){
        this.openLoader();
        return (<CustomerDocumentData
          id={this.CustomerId}
          me={this} />);
    }

    GetCustomerCertificateData(){
        this.openLoader();
        return (<CustomerCertificateData id={this.CustomerId} />);
    }

    GetCustomerAdditionalAdresses(){
        this.openLoader();
        return (<CustomerAdditionalAdresses id={this.CustomerId} />);
    }

    GetCustomerContractData(){
        this.openLoader();
        return(<CustomerContractData id={this.CustomerId} />);
    }

    GetCustomerRelationDelete(){
        this.openLoader();
        return(<CustomerRelationDelete id={this.CustomerId} />)
    }

    GetView(nameOfView){

        this.DeselectTabs();
        let content = "";

        switch (nameOfView){
            case "Data":
                this.SelectTab("DataTabLinkBurgerMenu");
                content = this.GetCustomerData(this.props.Id);
                break;
            case "Payment":
                this.SelectTab("PaymentTabLinkBurgerMenu");
                content = this.GetCustomerPaymentData(this.props.Id);
                break;
            case "Document":
                this.SelectTab("DocumentTabLinkBurgerMenu");
                content = this.GetCustomerDocumentData(this.props.Id);
                break;
            case "Certificate":
                this.SelectTab("CertificateTabLinkBurgerMenu");
                content = this.GetCustomerCertificateData(this.props.Id);
                break;
            case "AdditionalAdresses":
                this.SelectTab("AddidionalAdressesTabLinkBurgerMenu");
                content = this.GetCustomerAdditionalAdresses(this.props.Id);
                break;
            case "ContractData":
                this.SelectTab("ContractDataTabLinkBurgerMenu");
                content = this.GetCustomerContractData(this.props.id);
                break;
            case "RelationDelete":
                this.SelectTab("RelationDeleteTabLinkBurgerMenu");
                content = this.GetCustomerRelationDelete(this.props.id);
                break;
            default:
                this.SelectTab("DataTabLinkBurgerMenu");
                content = this.GetCustomerData(this.props.Id);
        }

        ReactDOM.render(content, document.getElementById('tabContent'));
    }

    SelectTab(id){
        $("#"+id).removeClass().addClass("activeTabBurgerMenu");
    }

    DeselectTabs()
    {
        $("#DataTabLinkBurgerMenu").removeClass().addClass("tab");
        $("#PaymentTabLinkBurgerMenu").removeClass().addClass("tab");
        $("#DocumentTabLinkBurgerMenu").removeClass().addClass("tab");
        $("#CertificateTabLinkBurgerMenu").removeClass().addClass("tab");
        $("#AddidionalAdressesTabLinkBurgerMenu").removeClass().addClass("tab");
        $("#ContractDataTabLinkBurgerMenu").removeClass().addClass("tab");
        $("#RelationDeleteTabLinkBurgerMenu").removeClass().addClass("tab");
    }

    componentDidMount()
    {
        let me = this;
        let body = $("body");
        //body.css("background-color", "white");
        body.bind("click",function(){
            var burgerMenuClick = localStorage.getItem("BurgerMenuCustomerCard","BurgerMenuCustomerCard");

            if(burgerMenuClick !== "BurgerMenuCustomerCard")
                {document.getElementById("mySidenavCustomerCard").style.width = "0";}
            else
                {localStorage.setItem("BurgerMenuCustomerCard","");}

            me.setState({});
        });

        $(document).keyup(function(e){

            if(e.which === 27){
                if($("#mySidenavCustomerCard").length>0)
                    {document.getElementById("mySidenavCustomerCard").style.width = "0";}

            }
        });

        let burgerMenu = $("#MenuCustomerCard");
        //body.css("background-color", "white");        
        burgerMenu.bind("click",function(){

            if(document.getElementById("mySidenavCustomerCard").style.width === "" || document.getElementById("mySidenavCustomerCard").style.width === "0px")
                {
                    document.getElementById("mySidenavCustomerCard").style.width = "auto";
                    localStorage.setItem("BurgerMenuCustomerCard","BurgerMenuCustomerCard");
                }

            me.setState({});
        });

        this.LogoClick();
    }

    SetLanguage(lang){
        localStorage.setItem("vas_language", lang);
        window.location = window.location.pathname;

        /*let language = localStorage.getItem('vas_language');
        let supportedLanguages = require('./i18n/languages.json');
        supportedLanguages.Languages.forEach(function(value){
            if(value.Iso !== language){
                localStorage.setItem("vas_language", value.Iso);
                window.location = window.location.pathname;
            }
        });*/
    }

    LogoClick(){

        var kontrastNumber = localStorage.getItem('Kontrast');
    
        if(kontrastNumber == "true"){
            $(".activeTabBurgerMenu").attr('style', 'background-color: #1d5c87; color: white !important;');
        }
      }


    render(){

        this.LogoClick();

        let payments = <tr>
            <td
            id={"PaymentTabLinkBurgerMenu"}
            className={"tab"}
            onClick={()=>{ this.GetView("Payment");}}>{Vas.Resources.Labels["MethodsOfPayment"]}</td>
        </tr>;

        let documents = <tr>
            <td
            id={"DocumentTabLinkBurgerMenu"}
            className={"tab"}
            onClick={()=>{ this.GetView("Document");}}>{Vas.Resources.Labels["Documents"]}</td>
        </tr>;

        let verifications = <tr>
            <td
            id={"CertificateTabLinkBurgerMenu"}
            className={"tab"}
            onClick={()=>{ this.GetView("Certificate");}}>{Vas.Resources.Labels["Verifications"]}</td>
        </tr>;
        
        let addresses = <tr>
            <td
            id={"AddidionalAdressesTabLinkBurgerMenu"}
            className={"tab"}
            onClick={()=>{ this.GetView("AdditionalAdresses");}}>{Vas.Resources.Labels["AdditionalAddresses"]}</td>
        </tr>;

        let contracts = '';

        let relationDelete = '';

        if(localStorage.getItem('vas_role') === "3"){
            contracts = <tr>
                <td
                id={"ContractDataTabLinkBurgerMenu"}
                className={"tab"}
                onClick={()=>{ this.GetView("ContractData");}}>{Vas.Resources.Labels["Contracts"]}</td>
            </tr>;

            // //TODO: wieder einkommentieren
            // relationDelete = <tr>
            // <td
            // id={"RelationDeleteTabLinkBurgerMenu"}
            // className={"tab"}
            // onClick={()=>{ this.GetView("RelationDelete");}}>Firmenzu-ordnung aufheben</td>
            // </tr>

          if(this.CustomerId === localStorage.getItem('vas_customerId')){
            payments= <tr></tr>;
            documents = <tr></tr>;
            verifications = <tr></tr>;
            contracts = <tr></tr>;
            addresses=<tr></tr>;
          } else{
            payments= '';
            documents = '';
            verifications = '';
            addresses='';
          }
        }

        return(<div id="mySidenavCustomerCard" className="SideNavCustomerCard">
            <table>
                <tbody>
                    <tr>
                        <td className={"customerCardLinksBurgerMenu"}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td
                                        id={"DataTabLinkBurgerMenu"}
                                        className={"activeTabBurgerMenu"}
                                        onClick={()=>{ this.GetView("Data");}} >{Vas.Resources.Labels["CustomerData"]}</td>
                                    </tr>
                                    {payments}
                                    {documents}
                                    {verifications}
                                    {contracts}   
                                    {addresses}
                                    {relationDelete}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody> 
            </table>
        </div>);
    }
}
export default SideNavigationCustomerCard;
